// extracted by mini-css-extract-plugin
export default {"option-card":"option-card__2ERnO","option-card_selected":"option-card_selected__2I3zb","skeleton-shimmer":"skeleton-shimmer__2mrxC"};